module.exports = __webpack_public_path__ + "static/logo-7db066232a7c40d74ff03f353509d010.png";